import React, { useContext, useEffect } from "react";
import gql from "graphql-tag";
import { withRouter } from "react-router-dom";
import CaseCard from "../CaseCard/CaseCard";
import CaseInformation from "../../../libs/CaseInformation";
import { useQuery } from "react-apollo";
import * as moment from "moment";

const QUERY = gql`
  query {
    getCurrentActiveCase(
      entity_type: ""
      status_code: ""
      client_name: ""
      contract_number: ""
      contract_name: ""
      start_date: ""
      end_date: ""
      finished: 1
    ) {
      id
      status_common
      prospect_probability
      contract {
        entity_type
        status_code
        created_date
        contract_name
        client {
          client_name
        }
      }
    }
  }
`;
const Approval = (props) => {
  const { loading, error, data, refetch } = useQuery(QUERY);

  function create_date(date) {
    const now = moment();
    const createDate = moment(date).format("YYYY-MM-DD");
    let range = now.diff(createDate, "day");

    switch (range) {
      case 1:
        return moment(date).format("HH:MM:SS");
        break;
      case 2:
        return "1 day ago, on" + moment(date).format("HH:MM:SS");
        break;
      case 3:
        return "2 day ago" + moment(date).format("HH:MM:SS");
        break;
      default:
        return moment(date).format("LLLL");
    }
  }

  useEffect(() => {
    const caseProgressData = (data?.getCurrentActiveCase ?? []).map(
      (x) => new CaseInformation(x)
    );
    // console.log(caseProgressData);
  }, [data]);

  return (
    <div>
      {loading && (
        <h4 className="text-center mt-5">
          <i className="fa fa-spin fa-spinner"></i> Please Wait...
        </h4>
      )}
      {error && (
        <div className="text-center">
          <h5>Some Error Occured</h5> {/*{JSON.stringify(error)} */}
        </div>
      )}

      {error && refetch()}

      {data ? (
        Object.keys(data.getCurrentActiveCase).length > 0 ? (
          (data?.getCurrentActiveCase ?? [])
            .filter((x) => x?.contract?.status_code === "CANCELLED")
            .map((index) => {
              return (
                <CaseCard
                  time={`Made on ${create_date(index.contract.created_date)}`}
                  approved={index?.status_common ?? ""}
                  title={index?.contract?.contract_name ?? ""}
                  name={`Client : ${
                    index?.contract?.client?.client_name ?? ""
                  }`}
                  // onClick={() =>
                  //   props.history.push({
                  //     pathname: `/caseboard/only_active`,
                  //     state: {
                  //       data: index.id,
                  //       open: true,
                  //       caseview: true,
                  //       approvals: false
                  //     }
                  //   })
                  // }
                />
              );
            })
        ) : (
          <div className="text-center mt-5" style={{ paddingTop: 50 }}>
            <img
              src={require("../../../images/nodataplus.png")}
              style={{ width: "40%" }}
              alt=""
            />
            <h5 className="text-center text-muted mt-5">No Data in Approval</h5>
          </div>
        )
      ) : null}
    </div>
  );
};
export default withRouter(Approval);
